import { useQuery } from 'react-query';
import VaultConnectionApi from './VaultConnectionApi';

const useAllConnections = () => {
    const {data, isLoading, isError, error, refetch} = useQuery('all-vault-connections', VaultConnectionApi.allConnections, { enabled:true });
    return { data, isLoading, isError, error, refetch}
};
export default useAllConnections;
